import { combineReducers } from 'redux'
import userReducer from './user'
import { UserModel } from '../../model/user.model'
import appReducer from './app'
import { AppModel } from '../../model/app.model'
import settingsReducer from './settings'
import botReducer from './botset'
import { BotSettings, BotSet } from '../../model/bot.model'
export interface ReduxStore {
    userInfo: UserModel | null
    appInfo: AppModel | null
    settingsInfo: BotSettings | null
    botSet: BotSet
}
export default combineReducers({
    userInfo: userReducer,
    appInfo: appReducer,
    settingsInfo: settingsReducer,
    botSet: botReducer,
})
